var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { Row } from "react-bootstrap";
import EdButton, { EdALinkButton, } from "@frameworks/web/components/generic/edbutton/edButton";
import EdModal from "../../../../../../shared-library/components/edModal";
import GenericTable from "../../../../../../shared-library/components/GenericTable";
import DpDetailsPopup from "./DpDetailsPopup";
import DpLedgerPage from "./DpLedger/DpLedgerPage";
import di from "../../di/serviceLocator";
import { useSelector } from "react-redux";
import { base64toZip } from "@frameworks/salesjourney/utils/genericMethods";
import { getDateInFormat } from "@domains/utils/reportDates";
import { ENominationStatus } from "@domains/salesFeatures/Clients/dto/iDpDetails";
import NominationDetails from "./NominationDetails";
var DpDetails = function () {
    var _a = __read(useState(false), 2), ledgerPopup = _a[0], setledgerPopup = _a[1];
    var _b = __read(useState(false), 2), detailsPopup = _b[0], setdetailsPopup = _b[1];
    var _c = __read(React.useState([]), 2), dpDeptailsDataState = _c[0], setDpDeptailsDataState = _c[1];
    var _d = __read(React.useState(), 2), dpDeptailsByDPId = _d[0], setDpDeptailsByDPId = _d[1];
    var _e = __read(React.useState(), 2), selectedRecord = _e[0], setSelectedRecord = _e[1];
    var _f = __read(useState(0), 2), categoryID = _f[0], setCategoryID = _f[1];
    var _g = __read(useState(false), 2), isShowNominationDetails = _g[0], setIsShowNominationDetails = _g[1];
    var _h = __read(useState([]), 2), nominationDetailsData = _h[0], setNominationDetailsData = _h[1];
    var _j = __read(useState(false), 2), nominationDetailsLoader = _j[0], setNominationDetailsLoader = _j[1];
    var DpDetailsColumn = [
        {
            columnName: "Depository",
            key: "depository",
        },
        {
            columnName: "DP Name",
            key: "dpName",
            tdCustomFunction: function (key) {
                return (React.createElement("div", { className: "dpname-btnblock" },
                    React.createElement("div", { className: "dpbtn-block" }, key)));
            },
        },
        {
            columnName: "DP ID",
            key: "dpId",
        },
        {
            columnName: "DP Account No.",
            key: "accountNo",
        },
        {
            columnName: "DP Status",
            key: "dpStatus",
        },
        {
            columnName: "POA",
            key: "poa",
        },
        {
            columnName: "DDPI",
            key: "ddpi",
        },
        {
            columnName: "Default DP",
            key: "defaultDP",
        },
        {
            columnName: "DP Ledger",
            tdCustomFunction: function () {
                return (React.createElement("div", { className: "dpbtn-block" },
                    React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "View", onClick: function () {
                            setledgerPopup(true);
                        } })));
            },
        },
        {
            columnName: "DP Details",
            key: "dpDetails",
            tdCustomFunction: function () {
                return (React.createElement("div", { className: "dpbtn-block" },
                    React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "View", onClick: function () {
                            setdetailsPopup(true);
                        } })));
            },
        },
        {
            columnName: "DP Back Office URL",
            key: "backOfficeURL",
            tdCustomFunction: function (key) {
                return (React.createElement("div", { className: "dpbtn-block" },
                    React.createElement(EdALinkButton, { target: "_blank", btnTyp: "midnight-blue", LinkHref: key, value: "View", className: "no_bg txt-midnight-blue text-decoration-underline" })));
            },
        },
        {
            columnName: "CML Report",
            key: "CMLReportbtn",
            keysForCustomFunction: ["DPAccountNo", "accountNo"],
            tdCustomFunction: function (keysForCustomFunction) {
                return (React.createElement("div", { className: "dpbtn-block" },
                    React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "View", onClick: function () {
                            downloadCMLReports(keysForCustomFunction[1]);
                        } })));
            },
        },
        {
            columnName: "Nomination",
            keysForCustomFunction: ["nominationStatus", "dpId", "accountNo"],
            tdCustomFunction: function (keysForCustomFunction) {
                switch (keysForCustomFunction[0]) {
                    case ENominationStatus.Opted_Out:
                        return React.createElement("div", null, keysForCustomFunction[0]);
                    case ENominationStatus.Opted_In:
                        return (React.createElement("div", { className: "dpbtn-block", "data-toggle": "modal", "data-target": "#exampleModalCenter" },
                            React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "View", onClick: function () {
                                    setIsShowNominationDetails(true);
                                    setNominationDetailsLoader(true);
                                    di.clients
                                        .getDpNomineeDetails({
                                        Accode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode,
                                        BOID: keysForCustomFunction[1] + keysForCustomFunction[2],
                                    })
                                        .then(function (data) {
                                        setNominationDetailsData(data.data);
                                        setIsShowNominationDetails(true);
                                        setNominationDetailsLoader(false);
                                    })
                                        .catch(function (err) {
                                        setNominationDetailsLoader(false);
                                    });
                                } })));
                    default:
                        return React.createElement("div", null, "Pending");
                }
            },
        },
    ];
    var dpDeptailsData = useSelector(function (state) { return state.Clients.DPDetails.reducersData.data; });
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    React.useEffect(function () {
        if (selectedAcount && selectedAcount.accountCode)
            di.clients.getDpDetailsData({ acCode: selectedAcount.accountCode });
    }, [selectedAcount]);
    React.useEffect(function () {
        // getDpNomineeDetailsdata(
        //   selectedAcount?.accountCode,
        //   dpDeptailsData[0]?.dpId + dpDeptailsData[0]?.accountNo
        // );
        setDpDeptailsDataState(dpDeptailsData);
        getDPDetailsByDPId();
    }, [dpDeptailsData, selectedRecord]);
    var getDPDetailsByDPId = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, di.clients
                        .getDPDetailsByDPId({
                        DpId: (selectedRecord === null || selectedRecord === void 0 ? void 0 : selectedRecord.dpId) + (selectedRecord === null || selectedRecord === void 0 ? void 0 : selectedRecord.accountNo),
                    })
                        .then(function (ResponseByDPId) {
                        setDpDeptailsByDPId(ResponseByDPId);
                    })
                        .catch(function (error) {
                        console.log("GetDPDetailsByDPID failure", error);
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var downloadCMLReports = function (dpAccountNo) { return __awaiter(void 0, void 0, void 0, function () {
        var cmlPayload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    cmlPayload = {
                        DpAccNo: dpAccountNo,
                    };
                    return [4 /*yield*/, di.clients
                            .downloadCMLReports(cmlPayload)
                            .then(function (CMLResponse) {
                            if (CMLResponse === null || CMLResponse === void 0 ? void 0 : CMLResponse.data) {
                                base64toZip(CMLResponse === null || CMLResponse === void 0 ? void 0 : CMLResponse.data, "CML_Reports_" + getDateInFormat(new Date(), "DD_MM_YYYY") + ".zip");
                            }
                            else {
                                alert("Data is not present");
                            }
                        })
                            .catch(function (error) {
                            console.log("CML Reports Download failure", error);
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "dp-details-block mx-0 px-0 section-padding" },
            React.createElement(Row, { className: "relationship-head-block mx-0 px-0" },
                React.createElement("div", { className: "DMSanBold_18_700 txt_blackOne1" }, "DP Details")),
            React.createElement("div", null,
                React.createElement(GenericTable, { columns: DpDetailsColumn, data: dpDeptailsDataState, parentClassName: "salestableParentClass table-responsive commonscroll-new", tableClassName: "salestableclass", rowOnClick: function (item, idx) {
                        setSelectedRecord(item);
                        setCategoryID(dpDeptailsDataState.length - idx);
                    }, message: {
                        msg: "No Data Found",
                        show: dpDeptailsDataState.length === 0 ? true : false,
                        icon: "",
                    } }))),
        React.createElement("div", { className: "modal-fullwidth" },
            React.createElement(EdModal, { show: ledgerPopup, setShow: setledgerPopup, showFooter: false, children: React.createElement(DpLedgerPage, { setledgershow: setledgerPopup, selectedRecord: selectedRecord, categoryID: categoryID }), modalTitle: "", title: "" })),
        React.createElement("div", { className: "modal-fullwidth" },
            React.createElement(EdModal, { show: detailsPopup, setShow: setdetailsPopup, showFooter: false, children: React.createElement(DpDetailsPopup, { dpname: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.clientName, AccCode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode, setledgershow: setdetailsPopup, data: [
                        { title: "DP ID", value: dpDeptailsByDPId === null || dpDeptailsByDPId === void 0 ? void 0 : dpDeptailsByDPId.dpid },
                        { title: "DP Ac No", value: dpDeptailsByDPId === null || dpDeptailsByDPId === void 0 ? void 0 : dpDeptailsByDPId.dpAcNo },
                        { title: "DP Name", value: dpDeptailsByDPId === null || dpDeptailsByDPId === void 0 ? void 0 : dpDeptailsByDPId.dpName },
                    ], allDPDeptailsByDPId: dpDeptailsByDPId }), modalTitle: "", title: "" })),
        React.createElement(EdModal, { show: isShowNominationDetails, setShow: setIsShowNominationDetails, showFooter: false, children: React.createElement(NominationDetails, { nominationData: nominationDetailsData, showLoader: nominationDetailsLoader }), modalTitle: "nomination-modal-title", title: "Nomination Details", closeDropdown: function () { }, closeOnOutsideClick: true })));
};
export default DpDetails;
